import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { customerApi, apiError } from "../context/CustomerContext";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setErr("Mínimo 8 caracteres"); return; }
    if (pw !== pw2) { setErr("Las contraseñas no coinciden"); return; }
    setState("busy"); setErr("");
    try { await customerApi.reset(token, pw); setState("done"); } catch (x) { setErr(apiError(x)); setState("idle"); }
  };
  const cls = "mt-1 w-full h-12 rounded-[8px] bg-[#143823] border border-[#F6EEDC]/25 px-3 text-[#F6EEDC] outline-none focus:border-[#F2B441]";
  return (
    <main data-testid="reset-page" className="max-w-[480px] mx-auto px-5 pt-28 pb-24">
      <h1 className="font-serif-d font-black text-4xl mb-6">Nueva contraseña</h1>
      {state === "done" ? (
        <p data-testid="reset-done">Contraseña cambiada. <Link to="/cuenta" className="underline underline-offset-4">Inicia sesión</Link>.</p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <label className="block"><span className="text-xs text-[#C9D6C2]">Nueva contraseña *</span>
            <input data-testid="reset-password" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className={cls} /></label>
          <label className="block"><span className="text-xs text-[#C9D6C2]">Repite la contraseña *</span>
            <input data-testid="reset-password-2" type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} className={cls} /></label>
          {err && <p data-testid="reset-error" className="text-sm text-[#F4A58F]">{err}</p>}
          <button type="submit" disabled={state === "busy"} data-testid="reset-submit" className="w-full h-12 rounded-full bg-[#8CD05A] text-[#0E2A1C] font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50">
            {state === "busy" && <Loader2 className="w-4 h-4 animate-spin" />} Guardar contraseña
          </button>
        </form>
      )}
    </main>
  );
}
